// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type {ReactElement} from 'react';

interface GroupRemoveUserFailedModalProps {
	username: string;
}
export const GroupRemoveUserFailedModal = observer(({username}: GroupRemoveUserFailedModalProps) => {
	const {t} = useLingui();
	const message: ReactElement = (
		<Trans>
			We couldn't remove the user from the group at this time. <strong>{username}</strong> is still in the group.
		</Trans>
	);
	return <GenericErrorModal title={t`Failed to Remove from Group`} message={message} />;
});
